<script setup>
import { Inertia } from '@inertiajs/inertia'
import UserList from '@/Components/Models/User/List';

const props = defineProps({
    adminUsers: {
        type: Object,
        default: () => ({}),
    },
});

function createAdminUser() {
	Inertia.visit('/users/create?role=admin');
}

function clicked(user) {
	Inertia.visit(`/users/${user.id}/edit`);
}
</script>

<template>
	<SectionCard 
		title="Admin accounts" 
		hint="These accounts can log in and administer the system including: adding and removing admin users, viewing and editing all member and contact information, connecting to a Xero account."
		:full-width="true"
	>
		<div
			class="
				flex flex-col
				w-full
				h-full
				overflow-y-auto
			"
			data-testid="admin-user-list"
		>
			<UserList
				:items="adminUsers"
				:pagination="adminUsers.length > 10"
				@item-clicked="clicked"
			/>
		</div>

		<template #footer>
			<Button
				data-testid="add-admin-user-btn"
				color="blue"
				@click="createAdminUser"
			>  
				Add Admin User 
			</Button>
		</template>

	</SectionCard>
</template>